import { render } from "./employee-count.vue?vue&type=template&id=68e1aee8&scoped=true"
import script from "./employee-count.vue?vue&type=script&lang=js"
export * from "./employee-count.vue?vue&type=script&lang=js"

import "./employee-count.vue?vue&type=style&index=0&id=68e1aee8&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e1aee8"]])

export default __exports__